import Sidebar from "../../../components/ui/sidebar";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Package as PackageIcon } from "lucide-react";
import { useState } from "react";

interface Package {
  id: number;
  title: string;
  date: string;
  time: string;
  status: string;
  hasImage: boolean;
  receivedBy: string;
  recipient: string;
}

const packages: Package[] = [
  { id: 1, title: "Sobre", date: "3 Septiembre 2025", time: "11:19 PM", status: "Entregado", hasImage: true, receivedBy: "Nombre portero renta casas", recipient: "Pepito Perez" },
  { id: 2, title: "Paquete", date: "3 Septiembre 2025", time: "11:19 PM", status: "En portería", hasImage: true, receivedBy: "Nombre portero renta casas", recipient: "Pepito Perez" },
  { id: 3, title: "Otro", date: "3 Septiembre 2025", time: "11:19 PM", status: "No hay imagen", hasImage: false, receivedBy: "Nombre portero renta casas", recipient: "Pepito Perez" },
];

export default function PackagesPage() {
  const [selectedPackage, setSelectedPackage] = useState<Package | null>(null);

  const openModal = (pkg: Package) => {
    setSelectedPackage(pkg);
  };

  const closeModal = () => {
    setSelectedPackage(null);
  };

  const handleReceivePackage = () => {
    if (selectedPackage) {
      alert(`Encomienda "${selectedPackage.title}" recibida por ${selectedPackage.recipient}`);
      closeModal();
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      {/* Sidebar */}
      <Sidebar />

      {/* Contenido principal */}
      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">Encomiendas</h2>

        {/* Tarjeta de Encomiendas */}
        <Card className="shadow-lg border-l-4 border-blue-500">
          <CardHeader>
            <CardTitle>Lista de Encomiendas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {packages.map((pkg) => (
                <div
                  key={pkg.id}
                  onClick={() => openModal(pkg)}
                  className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm cursor-pointer hover:bg-gray-50"
                >
                  <div className="flex items-center gap-4">
                    <PackageIcon size={24} className={pkg.hasImage ? "text-blue-500" : "text-gray-400"} />
                    <div>
                      <p className="font-medium">{pkg.title}</p>
                      <p className="text-sm text-gray-600">{pkg.date} {pkg.time}</p>
                    </div>
                  </div>
                  <span className={`
                    font-semibold
                    ${pkg.status === "Entregado" ? "text-green-600" : pkg.status === "No hay imagen" ? "text-red-600" : "text-yellow-600"}
                  `}>
                    {pkg.status}
                  </span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Modal de Detalle */}
        {selectedPackage && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
              <h3 className="text-xl font-bold mb-4">Detalle encomienda</h3>
              <div className="flex justify-center mb-4">
                <PackageIcon size={48} className="text-blue-500" />
              </div>
              <div className="space-y-2">
                <p><strong>Tipo:</strong> {selectedPackage.title}</p>
                <p><strong>Estado:</strong> {selectedPackage.status}</p>
                <p><strong>Recibido por:</strong> {selectedPackage.receivedBy}</p>
                <p><strong>Fecha:</strong> {selectedPackage.date} {selectedPackage.time}</p>
                <p><strong>Domiciliario:</strong> {selectedPackage.recipient}</p>
              </div>
              <button
                onClick={handleReceivePackage}
                className="mt-6 w-full bg-green-500 text-white py-2 rounded-full hover:bg-green-600 transition duration-300"
              >
                Recibir encomienda
              </button>
              <button
                onClick={closeModal}
                className="mt-2 w-full text-gray-500 hover:text-gray-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}